// API接口
export const API_URL = {
  // 初始化接口
  INIT: '/sdk/v1/init/start',
  // 向全员发送消息
  SEND_MESSAGE: '/sdk/v2/message/s-send',
  // 指定多个用户发送消息
  SEND_MESSAGE_DIRECT_MULTI: '/sdk/v2/message/s-send-group',
  // 指定单个用户发送消息
  SEND_MESSAGE_DIRECT_SINGLE: '/sdk/v2/message/s-send-single'
};

export const KV = {
  APP_ID: 'app_id',
  ROOM_ID: 'room_id',
  THIRD_PARTY_USER_ID: 'third_party_user_id',
  ACCESS_TOKEN: 'access_token',
  PACKAGE_CHECK: 'package_check',
  CLIENT: 'client',
  CHANNELID: 'channelid',
  API_SERVER: 'api_server'
};
